import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, of, catchError} from 'rxjs';
import {
  HHGDelinquencyReport,
  FRTDelinquencyReport
} from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class DelinquencyReportService extends DataService {
  private frtDelinquencyURI = this.apiUri + '/iffFrtDelinqList';
  private hhgDelinquencyURI = this.apiUri + '/iffHhgDelinqList';
  private hhgDelinquencyViewOnlyURI = this.apiUri + '/iffHhgDelinqListViewOnly/';
  private xtosDelinquencyViewOnlyURI = this.apiUri + '/xtosHhgDelinqListViewOnly/';
  private hhgIffDelinquentEmailURI = this.apiUri + '/iffemails/';
  private tspDelinquencyURI = this.apiUri + '/tspDelinqList/';

  constructor(http: HttpClient) {
    super(http);
  }

  HHGDelinquencyReport$ = this.http.get<HHGDelinquencyReport[]>(this.hhgDelinquencyURI)
    .pipe(catchError(this.handleError));

  FRTDelinquencyReport$ = this.http.get<FRTDelinquencyReport[]>(this.frtDelinquencyURI)
    .pipe(catchError(this.handleError));

  getIffDelinqReportViewOnly(year: number, quarter: number, moveType: string): Observable<any> {
    const iffDelinqReportUrl = this.hhgDelinquencyViewOnlyURI + year + '/year/' + quarter + '/quarter/'  + moveType + '/moveType';
    return this.http.get<any>(iffDelinqReportUrl);
  }

  getXtosDelinqReportViewOnly(year: number, quarter: number, moveType: string): Observable<any> {
    const iffDelinqReportUrl = this.xtosDelinquencyViewOnlyURI + year + '/year/' + quarter + '/quarter/'  + moveType + '/moveType';
    return this.http.get<any>(iffDelinqReportUrl);
  }

  getTspDelinqReport(carrierId: number, year: number, quarter: number, moveType: string): Observable<any> {
    const iffDelinqReportUrl = this.tspDelinquencyURI  + carrierId +'/carrierId/' + year + '/year/' + quarter + '/quarter/'  + moveType + '/moveType';
    return this.http.get<any>(iffDelinqReportUrl);
  }

  getIffDelinqYearViewOnly(): Observable<any> {
    const iffDelinqYearUrl = this.apiUri + '/iffHhgDelinqReportYearList';
    return this.http.get<any>(iffDelinqYearUrl);
  }

  getXtosDelinqYearViewOnly(): Observable<any> {
    const xtosDelinqYearUrl = this.apiUri + '/xtosHhgDelinqReportYearList';
    return this.http.get<any>(xtosDelinqYearUrl);
  }

  sendDelinquentEmails(year: number, quarter: number, businessType: string): Observable<any> {
    const iffDelinqEmailUrl = this.hhgIffDelinquentEmailURI + 'Y' + '/iffOneTimeEmail/' + year + '/' + quarter + '/' + businessType;
    return this.http.get<any>(iffDelinqEmailUrl);
  }

  getDelinqEmailStatus(year: number, quarter: number, businessType: string): Observable<any> {
    const iffDelinqEmailStatusUrl = this.hhgIffDelinquentEmailURI + 'Y' + '/delinqEmailStatus/' + year + '/' + quarter + '/' + businessType;
    // iffemails/Y/delinqEmailStatus/2019/1
    return this.http.get<any>(iffDelinqEmailStatusUrl);
  }
}
